import {
  Award,
  BarChart3,
  BookOpen,
  Calendar,
  CreditCard,
  FileQuestion,
  FileText,
  Gamepad2,
  GitBranch,
  Image as ImageIcon,
  Languages,
  LayoutGrid,
  Medal,
  Target,
  TrendingUp,
  Video,
} from 'lucide-react';

export const MAIN_TABS = [
  { id: 'progress', label: 'Progress', icon: Award },
  { id: 'resources', label: 'Resources', icon: BookOpen },
  { id: 'learning', label: 'Learning', icon: Gamepad2 },
  { id: 'billing', label: 'Billing', icon: CreditCard },
];

export const SUB_TABS = {
  progress: [
    { id: 'overview', label: 'Overview', icon: Target },
    { id: 'calendar', label: 'Calendar', icon: Calendar },
    { id: 'training', label: 'Training', icon: TrendingUp },
    { id: 'journey', label: 'Journey', icon: Award },
  ],
  learning: [
    { id: 'overview', label: 'Overview', icon: BookOpen },
    { id: 'vocabulary', label: 'Vocabulary', icon: Languages },
    { id: 'quizzes', label: 'Quizzes', icon: FileQuestion },
    { id: 'scenarios', label: 'Scenarios', icon: GitBranch },
    { id: 'badges', label: 'Badges', icon: Medal },
    { id: 'leaderboard', label: 'Leaderboard', icon: BarChart3 },
  ],
  resources: [
    { id: 'all', label: 'All Resources', desktopLabel: 'All', icon: LayoutGrid },
    { id: 'video', label: 'Videos', icon: Video },
    { id: 'document', label: 'Documents', icon: FileText },
    { id: 'image', label: 'Images', icon: ImageIcon },
  ],
};

export const orderAndFilterMemberTabs = (tabs, preferences = {}) => {
  const byId = new Map(tabs.map((tab) => [tab.id, tab]));
  const requested = Array.isArray(preferences.navigation_order)
    ? preferences.navigation_order
    : [];
  const order = [
    ...requested.filter((id, index) => byId.has(id) && requested.indexOf(id) === index),
    ...tabs.map(({ id }) => id).filter((id) => !requested.includes(id)),
  ];
  const hidden = new Set(
    Array.isArray(preferences.navigation_hidden)
      ? preferences.navigation_hidden.filter((id) => id !== 'progress')
      : [],
  );
  return order.filter((id) => !hidden.has(id)).map((id) => byId.get(id)).filter(Boolean);
};
